import { useState, useEffect } from 'react';
import axios, { AxiosResponse } from 'axios'
import { ID, Response } from '../../../../_metronic/helpers'
import { KTSVG } from '../../../helpers'
import clsx from 'clsx';
import { Link } from 'react-router-dom'
import { useMutation } from 'react-query';
import { UserModel, useAuth } from '../../../../app/modules/auth';


export interface AlertModel {
    id: ID
    title: string
    body: string
    time: string
    icon: string
    state: 'primary' | 'danger' | 'warning' | 'success' | 'info'
}

export type AlertModelQueryResponse = Response<Array<AlertModel>>

// export const initialUser: AlertModel = {

//     title: '',
//     body: '',
//     time: '',
//     icon: '',
//     state: 'primary'
// }


const API_URL = process.env.REACT_APP_THEME_API_URL
const NOTIFICATION_URL = `${API_URL}/notification_messages`


const getNotifications = (query: string): Promise<AlertModelQueryResponse> => {
    return axios
        .get(`${NOTIFICATION_URL}?${query}`)
        .then((d: AxiosResponse<AlertModelQueryResponse>) => d.data)
}
const deleteNotification = (Id: ID): Promise<AlertModelQueryResponse | undefined> => {
    return axios
        .delete(`${NOTIFICATION_URL}/${Id}`)
        .then((response: AxiosResponse<AlertModelQueryResponse>) => response.data)
        .then((response: AlertModelQueryResponse) => response)
}
const Notificatins = () => {
    const { currentUser, setCurrentUser } = useAuth();

    const [notificationsMessages, setNotificationsMessage] = useState<Array<AlertModel>>();

    useEffect(() => {
        // getNotifications('').then((result) => {
        //     setNotificationsMessage(result?.data);
        // });

        const fetchData = async () => {
            try {
                const result = await getNotifications('');
                setNotificationsMessage(result?.data);
                const currentUser1 = {
                    ...currentUser,
                    no_of_notification: result?.data?.length || 0
                }

                setCurrentUser(currentUser1 as UserModel | undefined);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        // Fetch data initially
        fetchData();

        // Set interval to fetch data every 1 or 2 minutes (60000 milliseconds = 1 minute)
        // const intervalId = setInterval(fetchData, 120000);

        // // Cleanup function to clear interval when component unmounts
        // return () => clearInterval(intervalId);
    }, []);

    const deleteItem = async (idToDelete: any) => {



        if (notificationsMessages && idToDelete != 'deleteall') {
            // setNotificationsMessage(notificationsMessages?.data.filter((message: any) => message.id !== idToDelete));
            notificationsMessages.splice(idToDelete, 1);
            console.log("notificationsMessages", notificationsMessages)
            const updatedAlerts = notificationsMessages.filter(alert => alert.id !== idToDelete);
            setNotificationsMessage(updatedAlerts)
        } else if (idToDelete == 'deleteall') {
            setNotificationsMessage([]);
        }

        await deleteNotification(idToDelete)
            .then((response) => {
                console.log(response);

            })
        const currentUser1 = {
            ...currentUser,
            no_of_notification: (idToDelete != 'deleteall' && currentUser?.no_of_notification) ? currentUser?.no_of_notification - 1 : 0,
        }

        setCurrentUser(currentUser1 as UserModel | undefined);

    };


    return (
        <>
            <div className=' my-5 px-2'>

                {notificationsMessages && notificationsMessages.map((alert, index) => (
                    <div key={`alert${index}`} className='d-flex flex-stack py-4'>
                        <div className='d-flex align-items-center'>
                            <div className='symbol symbol-35px me-4'>
                                <span className={clsx('symbol-label', `bg-light-${alert.state}`)}>

                                    {/* <KTSVG
                                        path={`/media/${alert.icon ? alert.icon : 'icons/duotune/communication/com003.svg'} `}
                                        className={`svg-icon-2 svg-icon-${alert.icon ? alert.icon : 'primary'}`}
                                    /> */}
                                    <span className={`svg-icon svg-icon-2 svg-icon-${alert.icon ? alert.icon : 'primary'}`}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M2 4V16C2 16.6 2.4 17 3 17H13L16.6 20.6C17.1 21.1 18 20.8 18 20V17H21C21.6 17 22 16.6 22 16V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4Z" fill="currentColor" />
                                            <path d="M18 9H6C5.4 9 5 8.6 5 8C5 7.4 5.4 7 6 7H18C18.6 7 19 7.4 19 8C19 8.6 18.6 9 18 9ZM16 12C16 11.4 15.6 11 15 11H6C5.4 11 5 11.4 5 12C5 12.6 5.4 13 6 13H15C15.6 13 16 12.6 16 12Z" fill="currentColor" />
                                        </svg>
                                    </span>
                                </span>
                            </div>

                            <div className='mb-0 me-2'>
                                <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bold'>
                                    {alert.title}
                                </a>
                                <div className='text-gray-400 fs-7'>{alert.body}</div>
                            </div>
                        </div>

                        <div className='min-w-75px d-flex justify-content-between'>
                            <span className='badge badge-light fs-8'>{alert.time}</span>
                            <span className='badge badge-danger fs-8 cursor-pointer' onClick={async () => await deleteItem(alert.id)} >X</span>
                        </div>

                    </div>
                ))}
            </div>
            {notificationsMessages && notificationsMessages?.length > 0 && (
                <div className='py-3 text-center border-top'>
                    <a
                        onClick={async () => await deleteItem('deleteall')}
                        // to='/crafted/pages/profile'
                        className='btn btn-color-gray-600 btn-active-color-primary'
                    >
                        Remove All <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                    </a>
                </div>
            )
            }
        </>

    )
}

export { Notificatins }